import axios from '@/axios'

// Media contents

export async function listMediaContents (page, parameters) {
  let url = import.meta.env.VITE_API_URL + '/v2/intranet/media-contents?page=' + page
  if (parameters) {
    url = url + parameters
  }

  const response = await axios.get(url)
  return response.data
}

export async function getMediaContent (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + id + '?with=sources,tags,units')
  return response.data.data
}

export async function createMediaContent (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents', data)
  return response.data.data
}
// investigar quick
// export async function quickSaveMediaContent (data) {
//   const response = await axios.post(import.meta.env.VITE_API_URL + '/v1/intranet/media-contents/quick-create', data)
//   return response.data.data
// }

export async function updateMediaContent (id, data) {
  await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + id, data)
}

export async function deleteMediaContent (id) {
  await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + id)
}

export async function addUnitToMedia (mediaId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + mediaId + '/units', data)
  return response.data.data
}
export async function removeUnitFromMedia (mediaId, unitId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + mediaId + '/units/' + unitId)
  return response.data.data
}

export async function addTagToMedia (mediaId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + mediaId + '/tags', data)
  return response.data.data
}
export async function removeTagFromMedia (mediaId, tagId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + mediaId + '/tags/' + tagId)
  return response.data.data
}

export async function addSourceToMedia (id, data) {
  await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + id + '/sources', data)
}

export async function removeSourceFromMedia (id, sourceId) {
  await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/media-contents/' + id + '/sources/' + sourceId)
}

export async function sendContentThumbnail (formData, id) {
  await axios.post(import.meta.env.VITE_API_URL + '/v1/intranet/media-contents/' + id + '/thumbnail', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export async function deleteContentThumbnail (id) {
  await axios.post(import.meta.env.VITE_API_URL + '/v1/intranet/media-contents/' + id + '/delete-thumbnail')
}

export default {
  listMediaContents,
  getMediaContent,
  createMediaContent,
  // quickSaveMediaContent,
  updateMediaContent,
  deleteMediaContent,
  addUnitToMedia,
  removeUnitFromMedia,
  addTagToMedia,
  removeTagFromMedia,
  addSourceToMedia,
  removeSourceFromMedia,
  sendContentThumbnail,
  deleteContentThumbnail
}
